import "./jquery-bootstrap";
import "./lib/moment";
// Leaflet moved to Better Desk leaflet.bundle.js (lazy-loaded via frappe.require).
import Sortable from "sortablejs";
window.SetVueGlobals = (app) => {
	app.config.globalProperties.__ = window.__;
	app.config.globalProperties.frappe = window.frappe;
};
window.Sortable = Sortable;
